/*
 * @Date: 2024-07-15 09:58:40
 * @LastEditTime: 2024-07-16 10:57:59
 * @Description: app module
 * @FilePath: /ql-official/src/store/modules/app.ts
 */

import { GetterTree, MutationTree, ActionTree } from "vuex";

const state = {
  device: "pc", // 默认是PC端，====》 PC端：pc、移动端：mobile
};

type State = typeof state;

const getters: GetterTree<State, unknown> = {
  device: (state) => state.device,
};

const mutations: MutationTree<State> = {
  SET_DEVICE: (state, device: string) => {
    state.device = device;
  },
};

const actions: ActionTree<State, unknown> = {
  setDevice({ commit }, device: string) {
    commit("SET_DEVICE", device);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
